import type { FacetsWithValues } from "@/modules/jobAds/client/utils/getAlgoliaFacetFiltersFromParams"
import type { AlgoliaFacet } from "@/modules/jobAds/types/jobAdFromAlgolia"

import _cloneDeep from "lodash/cloneDeep"

import { formatFiltersForAlgolia } from "@/modules/jobAds/client/utils/formatFiltersForAlgolia"

export const formatFiltersForFacetQuery = (facetFilters: FacetsWithValues, facetName: AlgoliaFacet): string => {
  if (facetName === "EXCLUSIVE" || facetName === "CREATED_BY_STUDENT_OR_ALUMNI" || facetName === "PARTNER_SCHOOL_IDS") {
    return formatFiltersForAlgolia(facetFilters, "CC_NETWORK")
  }
  if (facetName === "TAGS") {
    return formatFiltersForAlgolia(facetFilters)
  }
  return formatFiltersForAlgolia(facetFilters, facetName)
}
